import type { ApmBase, Transaction } from "@elastic/apm-rum";
import { grScope } from "@gr-common/async/logger";

export const apmAsyncScope = grScope.scope("apm");

/*                                            */
export const knownFields = ["transactions", "errors"] as const;
export const transactionTypes = ["page-load", "http-request"] as const;
export type TransactionType = (typeof transactionTypes)[number];

/**
 *
 *
 */
export type NoOps = [noopNull: () => null, noopUndefined: () => undefined];

/**
 *
 *
 */
export const noops: NoOps = [() => null, () => undefined];

/**
 *
 *
 *
 *
 *
 */
export const withTransaction =
  <R, A extends unknown[]>(
    agent: ApmBase,
    withCb: (transaction: Transaction, ...args: NoInfer<A>) => R,
  ): ((...args: A) => R) =>
  (...a) => {
    const transaction = agent.getCurrentTransaction();
    return transaction ? withCb(transaction, ...a) : (undefined as R);
  };
